export const generalInformation = [
  'Entity review',
  'Without entity participation',
  'Subscription',
  'Unsolicited',
];

export const generalInformationCreditReview = [
  'Entity review',
  'Subscription on request',
  'Unsolicited',
  'Without entity participation',
];
